"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _InputDateRange = _interopRequireDefault(require("./InputDateRange"));

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _useFormElementValidation = _interopRequireDefault(require("../../hooks/useFormElementValidation"));

var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.instanceOf(Date)]);

var optionShape = _propTypes.default.shape({
  id: _propTypes.default.string.isRequired,
  value: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  range: _propTypes.default.arrayOf(dateShape).isRequired
});

var selectedShape = _propTypes.default.shape({
  id: _propTypes.default.string,
  range: _propTypes.default.arrayOf(dateShape)
});

var getRange = function getRange(selectedId, selectedRange, options, customOptionId) {
  if (selectedId && customOptionId !== selectedId) {
    /* Even if a selectedRange comes in props, range is up to date with current date. 
    it is usefull if options are built relatively to new.Date() (meaning today) */
    var selectedOption = options && options.length && options.find(function (option) {
      return option.id === selectedId;
    });
    return selectedOption ? selectedOption.range : [];
  }

  return selectedRange || [];
};
/**
 * The InputDateSelect component offers a convenient way to display multiple choice in a period [InputDate, InputDate] selection
 */


var InputDateSelect = function InputDateSelect(_ref) {
  var ioFormat = _ref.ioFormat,
      selected = _ref.selected,
      options = _ref.options,
      customOptionId = _ref.customOptionId,
      controlledId = _ref.id,
      controlledName = _ref.name,
      label = _ref.label,
      helper = _ref.helper,
      inline = _ref.inline,
      displayAsButton = _ref.displayAsButton,
      checkboxesClassName = _ref.checkboxesClassName,
      checkboxesSize = _ref.checkboxesSize,
      color = _ref.color,
      outline = _ref.outline,
      required = _ref.required,
      locale = _ref.locale,
      icon = _ref.icon,
      withIconCalendar = _ref.withIconCalendar,
      onChange = _ref.onChange,
      onError = _ref.onError,
      className = _ref.className;
  var selectedId = selected.id,
      selectedRange = selected.range;

  var randomId = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;

  var name = controlledName || randomId;

  var _React$useState = _react.default.useState(selectedId),
      stateSelectedId = _React$useState[0],
      setSelectedId = _React$useState[1];

  var _React$useState2 = _react.default.useState(getRange(selectedId, selectedRange, options, customOptionId)),
      stateSelectedRange = _React$useState2[0],
      setSelectedRange = _React$useState2[1]; // const [stateSelectedRange, setSelectedRange] = React.useState(selectedRange || []);


  var _React$useState3 = _react.default.useState(selectedId === customOptionId),
      isCustom = _React$useState3[0],
      setIsCustom = _React$useState3[1];

  var _React$useState4 = _react.default.useState(false),
      error = _React$useState4[0],
      setError = _React$useState4[1];

  var _useFormElementValida = (0, _useFormElementValidation.default)(stateSelectedId, {
    required: required
  }),
      errors = _useFormElementValida[0],
      methods = _useFormElementValida[1];

  _react.default.useEffect(function () {
    setSelectedId(selectedId);
    setIsCustom(selectedId === customOptionId);
  }, [selectedId, customOptionId]);

  _react.default.useEffect(function () {
    var range = getRange(selectedId, selectedRange, options, customOptionId);
    setSelectedRange(range);
  }, [selectedId, selectedRange, options, customOptionId]);

  _react.default.useEffect(function () {
    setError(errors.length > 0);

    if (typeof onError === 'function') {
      onError({
        name: name,
        errors: errors.length ? errors : []
      });
    }
  }, [errors, onError, name]);

  var handleChange = function handleChange(checkedCheckbox, ref, event) {
    var _event$target = event.target,
        checkboxId = _event$target.id,
        checkboxValue = _event$target.value;
    var newStateChecked = stateSelectedId;
    var newStatePeriod = stateSelectedRange;

    if (checkedCheckbox) {
      newStateChecked = checkboxId;

      if (newStateChecked !== customOptionId) {
        newStatePeriod = options.find(function (option) {
          return option.value === checkboxValue;
        }).range;
        setSelectedRange(newStatePeriod);
        setIsCustom(false);
      } else {
        setIsCustom(true);
      }
    } else {
      newStateChecked = null;
      newStatePeriod = [];
      setSelectedRange([]);
      setIsCustom(false);
    }

    setSelectedId(newStateChecked);
    methods.onChangeCheckboxGroup(newStateChecked);

    if (typeof onChange === 'function') {
      onChange({
        id: newStateChecked,
        range: newStatePeriod
      }, name);
    }
  };

  var handleChangeCustom = function handleChangeCustom(value) {
    setSelectedRange(value);

    if (typeof onChange === 'function') {
      onChange({
        id: stateSelectedId,
        range: value
      }, name);
    }
  };

  var handleBlur = function handleBlur() {
    return methods.onChangeCheckboxGroup(stateSelectedId);
  }; // const handleUnselectAll = () => {
  //     if (stateSelectedId) {
  //         setSelectedId(null);
  //         setSelectedRange([]);
  //         setIsCustom(false);
  //         methods.onChangeCheckboxGroup([]);
  //         if (typeof onChange === 'function') {
  //             onChange({ id: null, range: [] }, name);
  //         }
  //     }
  // };


  var customDisplay = function customDisplay() {
    var display = '';

    if (stateSelectedId) {
      var opt = options.find(function (option) {
        return option.id === stateSelectedId;
      });
      if (opt) display = "" + opt.label;
    }

    return display;
  };

  var checkboxClasses = (0, _clsx.default)('uk-checkbox-group', (helper.length > 0 || error) && 'has-helper', error && 'has-error', inline && 'checkbox-group--inline');
  var containerClasses = (0, _clsx.default)('uk-input-date-select', 'uk-checkbox-multiple', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    withIcon: false,
    trigger: /*#__PURE__*/_react.default.createElement("div", {
      tabindex: "0"
    }, customDisplay(), "TO DO") // <Input
    //     disabled={!options || !options.length}
    //     readOnly
    //     className={stateSelectedId ? 'value-selected' : 'no-value-selected'}
    //     value={customDisplay()}
    //     floatLabel
    //     label={label}
    //     clearable
    //     icon={icon}
    //     onChange={handleUnselectAll}
    // />

  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "grid-x align-middle"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cell small-12 margin-bottom-1"
  }, /*#__PURE__*/_react.default.createElement(_InputDateRange.default, {
    ioFormat: ioFormat,
    locale: locale,
    value: stateSelectedRange,
    className: !isCustom && 'read-only',
    withIcon: withIconCalendar,
    clearable: isCustom,
    disabled: !isCustom,
    onChange: handleChangeCustom,
    color: color
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "cell small-12 checkbox-list-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "grid-y " + checkboxClasses
  }, options.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      key: item.id,
      name: item.name || name + "_" + i,
      id: item.id || randomId + "_" + i,
      label: item.label,
      checked: stateSelectedId === item.id || stateSelectedId === randomId + "_" + i,
      disabled: item.disabled || false,
      onChange: handleChange,
      onBlur: handleBlur,
      color: color,
      size: checkboxesSize,
      outline: outline,
      value: item.value,
      className: checkboxesClassName + " " + (item.id && item.id.search('custom') !== -1 ? 'custom' : ''),
      displayAsButton: displayAsButton
    });
  }), (helper.length > 0 || error) && /*#__PURE__*/_react.default.createElement("small", {
    className: "helper"
  }, error ? errors : helper))))));
};

InputDateSelect.propTypes = {
  /**
   * Format of in/out date
   */
  ioFormat: _propTypes.default.string,

  /**
   * Array of Checkboxes props
   */
  options: _propTypes.default.arrayOf(optionShape).isRequired,

  /**
   * Option to set as selected
   */
  selected: selectedShape,

  /**
   * Prefix for the Checkboxes id (unless it has been set in the options prop)
   */
  id: _propTypes.default.string,

  /**
   * Prefix for the Checkboxes name (unless it has been set in the options prop)
   */
  name: _propTypes.default.string,

  /**
   * Id of the option that enables dates range edition
   */
  customOptionId: _propTypes.default.string,

  /**
   * Label of the CheckboxeGroup
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /**
   * Layout of the CheckboxeGroup
   */
  inline: _propTypes.default.bool,

  /**
   * Change the display of the CheckboxeGroup
   */
  displayAsButton: _propTypes.default.bool,

  /**
   * ClassName to apply to InputDateSelect
   */
  className: _propTypes.default.string,

  /**
   * ClassName to apply to each Checkbox
   */
  checkboxesClassName: _propTypes.default.string,

  /**
   * Size of the Checkboxes
   */
  checkboxesSize: _propTypes.default.oneOf(['tiny', 'small', 'default', 'large', 'big']),

  /**
   * Background-color of selected Checkboxes (or checkmark color if outline)
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'secondary', 'success', 'alert', 'warning', 'white']),

  /**
   * Invert styling colors of the Checkboxes
   */
  outline: _propTypes.default.bool,

  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,

  /**
   * Form-validation: set the CheckboxGroup as required
   */
  required: _propTypes.default.bool,

  /**
   * Icon of selector input
   */
  icon: _propTypes.default.string,

  /**
   * Callback function onChange triggered when date range or selection changed
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function onError
   */
  onError: _propTypes.default.func,

  /**
   * Add a decorative calendar icon to the DatePicker
   */
  withIconCalendar: _propTypes.default.bool
};
InputDateSelect.defaultProps = {
  ioFormat: 'jsDate',
  selected: {},
  label: '',
  checkboxesSize: 'default',
  color: 'default',
  outline: false,
  inline: false,
  required: false,
  helper: '',
  checkboxesClassName: '',
  className: '',
  displayAsButton: false,
  withIconCalendar: false,
  onChange: function onChange() {},
  onError: function onError() {}
};
var _default = InputDateSelect;
exports.default = _default;